// extracted by mini-css-extract-plugin
export default {"participantDrawerCheckbox":"YRV5m9wCwToax4j021PN"};